import { CreateVehicleResponse } from '../../app/features/vehicles/domain/vehicle.model';
import { VehicleStatus } from '../../app/features/vehicles/infrastructure/enums/vehicle-status.enum';
import { MROType } from '../../app/features/vehicles/infrastructure/enums/mro-type.enum';
import { ReadingType } from '../../app/features/vehicles/infrastructure/enums/reading-type.enum';
import { MroStatus } from '../../app/features/vehicles/infrastructure/enums/mro-status.enum';
import { VehicleReason } from '../../app/features/vehicles/infrastructure/enums/vehicle-reasons.enum';
import { MroReason } from '../../app/features/vehicles/infrastructure/enums/mro-reason.enum';

export const createVehicleResponseMock: CreateVehicleResponse = {
    mroType: MROType.ODOMETER_CAPTURE,
    id: 'c7662d8a-0eaf-4127-b43c-d9e9d7657b62',
    status: {
        name: VehicleStatus.ENROLLED,
        reason: VehicleReason.USER_REQUESTED,
        dateTime: '2020-01-01',
    },
    make: 'test Make',
    model: 'test Model',
    year: 2020,
    selectedModelId: 1,
    selectedAddressId: 'test address',
    availableModels: [
        {
            id: 12,
            make: 'test Make',
            baseModel: 'test model',
            model: 'test model2',
            year: 2020,
            summary: 'summary test',
            description: 'description test',
            displacement: {
                value: 1.6,
                unit: 'unit test',
            },
            drive: {
                code: '2WD',
                description: '2-Wheel Drive',
            },
            cylinders: {
                value: 1,
                unit: 'test cylinders',
            },
            transmission: {
                value: 'trTest',
            },
            engineDescription: {
                value: 'edTest',
            },
            fuelType: {
                primary: 'ptest',
                secondary: 'stest',
            },
        },
        {
            id: 123,
            make: 'test Make',
            baseModel: 'test model',
            model: 'test model2',
            year: 2020,
            summary: 'summary test',
            description: 'description test',
            displacement: {
                value: 1.6,
                unit: 'unit test',
            },
            drive: {
                code: '2WD',
                description: '2-Wheel Drive',
            },
            cylinders: {
                value: 1,
                unit: 'test cylinders',
            },
            transmission: {
                value: 'trTest',
            },
            engineDescription: {
                value: 'edTest',
            },
            fuelType: {
                primary: 'ptest',
                secondary: 'stest',
            },
        },
        {
            id: 124,
            make: 'test Make',
            baseModel: 'test model',
            model: 'test model2',
            year: 2020,
            summary: 'summary test',
            description: 'description test',
            displacement: {
                value: 1.6,
                unit: 'unit test',
            },
            drive: {
                code: '2WD',
                description: '2-Wheel Drive',
            },
            cylinders: {
                value: 1,
                unit: 'test cylinders',
            },
            transmission: {
                value: 'trTest',
            },
            engineDescription: {
                value: 'edTest',
            },
            fuelType: {
                primary: 'ptest',
                secondary: 'stest',
            },
        },
    ],
    vin: '123456789abcdefgh',
    addressData: {
            id: 'testId',
            alias: 'test alias',
            address: 'test address',
            zipCode: 'test zipCode',
            city: 'test city',
            county: 'test county',
            country: 'test country',
            state: {
                code: 'test code',
                name: 'test name',
            },
    },
    mroData: {
        id: 'testId',
        status: {
            name: MroStatus.ACTIVATED,
            reason: MroReason.PENDING_FIRST_CONNECTION,
            dateTime: '2020-01-01',
        },
        initialMilesReading: {
            reportingPeriodId: 'test reportingPeriodId',
            readingType: ReadingType.INITIAL_READING,
            miles: 1,
            readingDate: 'test readingDate',
            readingPeriodStartDate: 'test readingPeriodStartDate',
            readingPeriodEndDate: 'test readingPeriodEndDate',
            incrementMiles: 1,
        },
        lastMilesReading: {
            reportingPeriodId: 'test reportingPeriodId',
            readingType: ReadingType.DEACTIVATION_READING,
            miles: 1,
            readingDate: 'test readingDate',
            readingPeriodStartDate: 'test readingPeriodStartDate',
            readingPeriodEndDate: 'test readingPeriodEndDate',
            incrementMiles: 1,
        },
        finalMilesReading: {
            reportingPeriodId: 'test reportingPeriodId',
            readingType: ReadingType.COMPLIANCE_RECOVERY_READING,
            miles: 1,
            readingDate: 'test readingDate',
            readingPeriodStartDate: 'test readingPeriodStartDate',
            readingPeriodEndDate: 'test readingPeriodEndDate',
            incrementMiles: 1,
        },
        createdAt: 'test createdAt',
        updatedAt: 'test updatedAt',
    },
};
